import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import AnnotateIcon from '../core/icons/Annotate';
import { globalStyles } from './style/gstheme';
import { computeStatements } from './utils/utils';
import ReifyButtonInner from './ReifyButtonInner';

const styles = () => {
  return Object.assign({
    noAnnotate: {
      backgroundColor: '#c0c0c0',
      borderTopLeftRadius: 12,
      borderBottomLeftRadius: 12,
      height: 24,
      paddingLeft: 4,
      display: 'inline-block',
      transform: 'translateY(1px)'
    },
    annotate: {
      backgroundColor: '#808080',
      borderTopLeftRadius: 12,
      borderBottomLeftRadius: 12,
      height: 24,
      paddingLeft: 4,
      display: 'inline-block',
      transform: 'translateY(1px)',
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: '#a0a0a0'
      }
    }
  }, globalStyles);
};

class ReifyButton extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: props.applicableStatements && props.applicableStatements.length > 0,
      applicableStatementsCount: props.applicableStatements ? props.applicableStatements.length : 0
    };
    this.cancellable = null;
  }

  static getDerivedStateFromProps(props, state) {
    if (props.applicableStatements && props.applicableStatements.length !== state.applicableStatementsCount) {
      return {
        isLoading: props.applicableStatements.length > 0,
        applicableStatementsCount: props.applicableStatements.length
      };
    }
    return null;
  }

  componentDidUpdate() {
    if (this.state.isLoading === true) {
      this.getStatements();
    }
  }

  componentDidMount() {
    if (this.props.applicableStatements) {
      this.getStatements();
    }
  }

  getStatements = () => {
    const statements = computeStatements(this.props.applicableStatements, this.props.property, this.props.value);
    this.setState({ statements, isLoading: false });
  };

  render() {

    const { onReify, subject, property, value, graph, isReadOnly, classes } = this.props;
    const { statements } = this.state;
    const exists = statements && statements.length > 0;

    return (
      exists ?
        <Tooltip title="Show annotation detail">
          <span onClick={() => onReify(true, subject, property, value)} data-test="edit-annotation">
            <ReifyButtonInner
              key={statements[0].id}
              id={statements[0].id}
              graph={graph} />
          </span>
        </Tooltip>
        :
        isReadOnly ?
          <span className={classes.noAnnotate} data-test="annotate-button-read-only">
            <span
              style={{
                color: 'white'
              }}>
              <AnnotateIcon />
            </span>
          </span>
          :
          <Tooltip title="Annotate">
            <span className={classes.annotate} data-test="annotate-button">
              <span data-test="add-annotation"
                style={{
                  color: 'white'
                }}>
                <AnnotateIcon onClick={() => onReify(true, subject, property, value)} />
              </span>
            </span>
          </Tooltip>
    );
  }
}


ReifyButton.propTypes = {
  classes: PropTypes.object,
  graph: PropTypes.string.isRequired,
  onReify: PropTypes.func,
  subject: PropTypes.string.isRequired,
  property: PropTypes.string.isRequired
};

export default withStyles(styles)(ReifyButton);